import { StoreConfigurationFunction } from './models/store-configuration-function';

let dynamicConfigureStore: StoreConfigurationFunction;

/* tslint:disable */
/* Use require instead of es6 import to dynamically determine store configuration function */
if (process.env['NODE_ENV'] === 'production') {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    dynamicConfigureStore = require('./configure-store.prod').configureStore;
} else {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    dynamicConfigureStore = require('./configure-store.dev').configureStore;
}
/* tslint:enable */

export const configureStore = dynamicConfigureStore;
